export const servicesData = [
  {
    id: 1,
    icon: 'ri-file-text-line',
    title: 'Individual Tax Preparation',
    description: 'Comprehensive tax filing services for individuals with personalized strategies to maximize your refund and minimize liability.',
  },
  {
    id: 2,
    icon: 'ri-briefcase-line',
    title: 'Business Tax Planning',
    description: 'Strategic tax planning for businesses of all sizes, ensuring compliance while optimizing your tax position year-round.',
  },
  {
    id: 3,
    icon: 'ri-shield-check-line',
    title: 'IRS Representation',
    description: 'Expert representation before the IRS for audits, appeals, and tax disputes with proven success in resolving complex cases.',
  },
  {
    id: 4,
    icon: 'ri-search-line',
    title: 'Audit Support',
    description: 'Comprehensive audit defense and support services to protect your interests and navigate IRS examinations confidently.',
  },
  {
    id: 5,
    icon: 'ri-home-heart-line',
    title: 'Estate Planning',
    description: 'Strategic estate and gift tax planning to preserve wealth for future generations while minimizing tax obligations.',
  },
  {
    id: 6,
    icon: 'ri-calendar-check-line',
    title: 'Quarterly Consulting',
    description: 'Ongoing quarterly tax consulting to keep your finances optimized and ensure you are prepared for tax season year-round.',
  },
];

export const featuresData = [
  {
    id: 1,
    icon: 'ri-time-line',
    title: 'Fast Turnaround',
    description: 'Quick processing with most returns completed within 48 hours',
    metric: '48hrs',
  },
  {
    id: 2,
    icon: 'ri-money-dollar-circle-line',
    title: 'Maximum Refunds',
    description: 'Average client refund increase of 23% compared to self-filing',
    metric: '+23%',
  },
  {
    id: 3,
    icon: 'ri-customer-service-2-line',
    title: 'Year-Round Support',
    description: 'Unlimited consultations and support available 365 days a year',
    metric: '24/7',
  },
  {
    id: 4,
    icon: 'ri-shield-star-line',
    title: 'Audit Protection',
    description: 'Free audit defense included with every tax preparation service',
    metric: '100%',
  },
  {
    id: 5,
    icon: 'ri-award-line',
    title: 'IRS Certified',
    description: 'All preparers are IRS certified with continuing education',
    metric: 'Certified',
  },
];
